<div
  class="tooltip-container"
  data-cy="tooltip-container"
  [class]="tooltipClass"
  [@state]="visibility"
  (@state.done)="animationDone($event)"
>
  <ng-template [cdkPortalOutlet]="cdkPortal"></ng-template>
</div>
